import { ALL_FEATURES } from '../../company/features';

/** Mary is the base backend: every feature is on. */
const MARY_FEATURES = Object.freeze(Object.fromEntries(ALL_FEATURES.map((feature) => [feature, true])));

export default MARY_FEATURES;
